import { makeUrl } from "../utils/urls";
import { getApi, postApi } from "./apiCalls";

export const getAddresses = (customerId) => {
  return new Promise((resolve, reject) => {
    const url = makeUrl(`riders/customers/${customerId}/addresses`);
    getApi(url, {}, true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const saveAddress = (customerId, addressData) => {
  return new Promise((resolve, reject) => {
    const url = makeUrl(`riders/customers/${customerId}/addresses`);
    postApi(url, { ...addressData }, "post", true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by your browser."));
    } else {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          resolve({ latitude, longitude });
        },
        (error) => {
          reject(new Error(`Geolocation error: ${error.message}`));
        }
      );
    }
  });
};
